import { ComponentLoader } from "@bythepixel/component-loader";
import InViewSrc from "@bythepixel/in-view-src";
import ClipboardCopy from "@Core/components/clipboardCopy";
import Form from "@Core/components/form";
import InputGroup from "@Core/components/inputGroup";
import DynamicTextArea from "@Core/components/dynamicTextArea";
import { BasicMap } from "@Core/components/maps";
import Modal from "@Core/components/microModalAdpt";
import {
  GallerySlider,
  SectionGeneralSlider,
  ThumbnailSlider,
} from "@Core/components/sliders";
import ProfileMenu from "@Core/components/profileMenu";
import SectionTabs from "@Core/components/sectionTabs";
import StickySubnavigation from "@Core/components/stickySubnavigation";
import YouTubePlayerWrapper from "@Core/components/youTubePlayerWrapper";
import BlogIndexLoadMoreButton from "@Core/components/blogIndexLoadMoreButton";
import { InputDatePicker } from "@Core/components/datePicker";
import Gdpr from '@Core/components/gdpr';
import RedirectFromManagement from "../RedirectFromManagement";

window.global = new ComponentLoader(document, [
  InViewSrc,
  BasicMap,
  ClipboardCopy,
  Form,
  InputGroup,
  DynamicTextArea,
  Modal,
  GallerySlider,
  SectionGeneralSlider,
  ThumbnailSlider,
  ProfileMenu,
  SectionTabs,
  StickySubnavigation,
  YouTubePlayerWrapper,
  BlogIndexLoadMoreButton,
  InputDatePicker,
  Gdpr,
]);

RedirectFromManagement.listen();
